import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useServices } from "@/hooks/useServices";
import { ServiceDialog } from "./ServiceDialog";
import { ServicesTable } from "./ServicesTable";

export function ServicesListView() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedService, setSelectedService] = useState<string | null>(null);
  const { services, isLoading } = useServices();

  const handleEdit = (id: string) => {
    setSelectedService(id);
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
    setSelectedService(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">Cadastro de Serviços</h2>
          <p className="text-muted-foreground">Gerencie os serviços oferecidos</p>
        </div>
        <Button onClick={() => setIsDialogOpen(true)}>
          <Plus className="h-4 w-4 mr-2" />
          Novo Serviço
        </Button>
      </div>

      <ServicesTable
        services={services}
        isLoading={isLoading}
        onEdit={handleEdit}
      />

      <ServiceDialog
        open={isDialogOpen}
        onOpenChange={handleCloseDialog}
        serviceId={selectedService}
      />
    </div>
  );
}
